import React from "react";
import { SafeAreaView, ScrollView, View } from "react-native";

type Props = {
  children: React.ReactNode;
};

export default function ScreenContainer({ children }: Props) {
  return (
    <SafeAreaView className="flex-1">
      <ScrollView
        contentContainerStyle={{ paddingBottom: 20, paddingTop: 20 }}
        showsVerticalScrollIndicator={false}
        className="flex-1"
      >
        <View className="w-full items-center">
          <View className="w-full px-4">
            <View className="p-4 bg-white rounded-lg shadow-xs">
              {children}
            </View>
          </View>
        </View>
      </ScrollView>
    </SafeAreaView>
  );
}
